import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconFilterFilled = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.08482 5.57912C5.23443 5.22596 5.55758 5 5.91305 5H18.0869C18.4424 5 18.7656 5.22596 18.9152 5.57912C19.0648 5.93229 19.0137 6.34845 18.7841 6.64572L14.1304 12.6728V18C14.1304 18.3466 13.9666 18.6684 13.6974 18.8506C13.4282 19.0329 13.0921 19.0494 12.8091 18.8944L10.3743 17.5611C10.065 17.3917 9.86957 17.0454 9.86957 16.6667V12.6728L5.21588 6.64573C4.98635 6.34845 4.93521 5.93229 5.08482 5.57912Z"
        />
      </svg>
    );
  }
);
